import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './common/custom-route-reuse.strategy';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './common/ui-components/components.module';
import { ActionSheetModule } from './common/ui-components/action-sheet/action-sheet.module';
import { RatingModule } from './common/ui-components/rating/rating.module';

import { AppComponent } from './app.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthInterceptor } from './Authentication/auth.interceptor';
import { LogoutComponent } from './common/ui-components/logout/logout.component';
import { SessionLogoutComponent } from './common/ui-components/session-logout/session-logout.component';
import { ServiceNearModule } from './third-party/service-near/service-near.module';
import { GlobalErrorHandler } from './global-error-handler';
import { LogglyService } from './services/loggly.service';
import { MenuLayoutComponent } from './layout/menu-layout/menu-layout.component';

@NgModule({ declarations: [
        AppComponent,
        LogoutComponent,
        SessionLogoutComponent,
        MenuLayoutComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
        ComponentsModule,
        NoopAnimationsModule,
        BrowserAnimationsModule,
        NgxSkeletonLoaderModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        ActionSheetModule,
        RatingModule,
        NgSelectModule,
        AngularFireMessagingModule,
        ServiceNearModule], providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: RouteReuseStrategy,
            useClass: CustomRouteReuseStrategy,
        },
        Title,
        LogglyService,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
